import type { BusinessAccess } from '../hooks/useBusinessAccessInvitations';

/**
 * Destination of an invitations-list row. Residential invitations come back
 * from /business_access/combined with the estate broken down
 * (destination_group / destination_building / destination_estate); a business
 * pass only has its business name.
 */
export function getDestinationParts(row: BusinessAccess, eventName?: string): { primary: string; secondary: string } {
  const estate = row.destination_estate || row.business_name || '';
  const context = [row.destination_group, row.destination_building].filter(Boolean).join(' · ');
  // SAM-1320 (U35): the pass of an event is for the event; its business is the context under it
  if (eventName) return { primary: eventName, secondary: [estate, context].filter(Boolean).join(' · ') };
  return { primary: estate, secondary: context };
}

/** A pass created for an event (SAM-1304): a business pass that carries the event's id. */
export const isEventPass = (row: { entity?: string; event_id?: unknown }): boolean =>
  row.entity !== 'invitation' && row.event_id !== null && row.event_id !== undefined && row.event_id !== '';

/** "Group · Building · Estate" on one line, for CSV and plain-text uses. */
export function getDestinationText(row: BusinessAccess, eventName?: string): string {
  const { primary, secondary } = getDestinationParts(row, eventName);
  return [secondary, primary].filter(Boolean).join(' · ');
}

// Invitations have no delivery channel; the backend answers where they came
// from instead. Business passes answer their business_access_channel name.
const INVITATION_ORIGIN_LABELS: Record<string, string> = {
  app: 'Resident app',
  staff: 'Office',
  import: 'Imported',
};

export function getChannelLabel(row: BusinessAccess): string {
  const channel = row.channel;
  if (!channel) return '';
  return INVITATION_ORIGIN_LABELS[channel] || channel;
}
